import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

const ConfirmEmailPage = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      setStatus('invalid');
      return;
    }
    fetch(`${process.env.REACT_APP_API_URL}/confirm-email?token=${token}`)
      .then(res => {
        setStatus(res.ok ? 'success' : 'error');
      })
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="max-w-md w-full px-6 py-10 border rounded-lg shadow-sm text-center">
        <h1 className="text-xl font-semibold mb-3">Email Confirmation</h1>
        {status === 'loading' && <p className="text-muted-foreground">Confirming your email...</p>}
        {status === 'success' && (
          <>
            <p className="text-green-600 mb-4">Your email has been confirmed. You can now log in.</p>
            <a href="/install" className="text-sm text-primary underline">Go to login</a>
          </>
        )}
        {status === 'error' && (
          <p className="text-destructive">Confirmation failed. The link may have already been used or expired.</p>
        )}
        {status === 'invalid' && (
          <p className="text-destructive">Invalid confirmation link.</p>
        )}
      </div>
    </div>
  );
};

export default ConfirmEmailPage;
